export default __webpack_public_path__ + "static/media/jaisalmer.d0853b04.jpg";